import { put, getByKey, deleteItem } from './utils/transactionHelpers'

// Dashboard data always uses 'dashboardData' as the fixed ID
const DASHBOARD_ID = 'dashboardData'

export const saveDashboardData = async dashboardData => {
    try {
        await put('dashboard', {
            id: DASHBOARD_ID,
            summary: dashboardData,
        })
    } catch (error) {
        console.error('Failed to save dashboard data:', error)
        throw error
    }
}

export const getDashboardData = async () => {
    try {
        const result = await getByKey('dashboard', DASHBOARD_ID)
        return result ? result.summary : null
    } catch (error) {
        console.error('Failed to fetch dashboard data:', error)
        return null
    }
}

export const deleteDashboardData = async () => {
    try {
        await deleteItem('dashboard', DASHBOARD_ID)
        console.log('Dashboard data deleted successfully')
    } catch (error) {
        console.error('Error deleting dashboard data:', error)
        throw error
    }
}
